import { enumFontIconWeights, kfontIconNameDuotone } from "../constants";
import { fontIconString } from "./fontIconString";

export function fontIconStringDuotone(size) {
  return fontIconString(size, enumFontIconWeights.bold, kfontIconNameDuotone);
}
